export default [
  {
    label: '早朝イン',
    value: 'early_check_in',
  },
  {
    label: '午後アウト',
    value: 'late_check_out',
  },
];
